import { enGB as enLocale } from 'date-fns/locale/en-GB';
import { FormattedMessage } from 'react-intl';

import NextRepaymentText from './nextRepaymentText/NextRepaymentText';
import styles from './StatusLines.module.css';
import { ListSVG } from '../../../../svgComponents/listSVG/index';

export const StatusLines = ({
    hasRepaymentSchedule,
    totalBalance,
    isPaymentOverdue,
    repaymentDate,
    repaymentAmount,
    showSchedule,
    isSecondCBILSOffer
}: {
    hasRepaymentSchedule: boolean;
    totalBalance: number;
    repaymentDate: string;
    repaymentAmount: number;
    showSchedule: () => void;
    isPaymentOverdue?: boolean;
    isSecondCBILSOffer?: boolean;
}) => {
    if (!totalBalance) {
        return null;
    }

    if (hasRepaymentSchedule) {
        return (
            <div className={styles.StatusLines}>
                <div className={styles.nextRepayment}>
                    <NextRepaymentText
                        locale={enLocale}
                        totalBalance={totalBalance}
                        amount={repaymentAmount}
                        date={repaymentDate}
                        isPaymentOverdue={isPaymentOverdue}
                    />
                </div>
                <div className={styles.showSchedule}>
                    <span className={styles.link} onClick={showSchedule}>
                        {isSecondCBILSOffer ? (
                            'See full 2nd CBILS repayment schedule'
                        ) : (
                            <FormattedMessage
                                id="_.status_lines.see_repayment_schedule"
                                defaultMessage="See repayment schedule"
                            />
                        )}
                    </span>
                </div>
            </div>
        );
    } else {
        return (
            <div className={styles.showSchedule}>
                <span className={styles.icon}>
                    <ListSVG />
                </span>
                <span className={styles.link} onClick={showSchedule}>
                    <FormattedMessage
                        id="_.status_lines.see_repayment_breakdown"
                        defaultMessage="Click here to see your repayment breakdown"
                    />
                </span>
            </div>
        );
    }
};
